import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgSelectModule } from "@ng-select/ng-select";
import { ArchwizardModule } from 'angular-archwizard';

import { SharedService } from './services/shared.service';
import { AlertInfoComponent } from "./components/alert-info/alert-info.component";
import { SharedHeaderComponent } from './components/shared-header/shared-header.component';
import { SharedFooterComponent } from './components/shared-footer/shared-footer.component';
import { SharedLoadingComponent } from './components/shared-loading/shared-loading.component';
import { SharedSiriemaComponent } from './components/shared-siriema/shared-siriema.component';
import { SharedBrasaoMsComponent } from './components/shared-brasao-ms/shared-brasao-ms.component';
import { SharedFormErrorComponent } from './components/shared-form-error/shared-form-error.component';
import { SharedMenuLateralComponent } from './components/shared-menu-lateral/shared-menu-lateral.component';
import { SharedHeaderCadastroComponent } from './components/shared-header-cadastro/shared-header-cadastro.component';
import { SharedSpinnerLoadingComponent } from './components/shared-spinner-loading/shared-spinner-loading.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    ArchwizardModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    NgxMaskModule,
    NgSelectModule,
    ArchwizardModule,
    AlertInfoComponent,
    SharedHeaderComponent,
    SharedFooterComponent,
    SharedLoadingComponent,
    SharedSiriemaComponent,
    SharedBrasaoMsComponent,
    SharedFormErrorComponent,
    SharedMenuLateralComponent,
    SharedSpinnerLoadingComponent,
    SharedHeaderCadastroComponent
  ],
  declarations: [
    AlertInfoComponent,
    SharedHeaderComponent,
    SharedFooterComponent,
    SharedLoadingComponent,
    SharedSiriemaComponent,
    SharedBrasaoMsComponent,
    SharedFormErrorComponent,
    SharedMenuLateralComponent,
    SharedSpinnerLoadingComponent,
    SharedHeaderCadastroComponent
  ],
  providers: [
    SharedService
  ],
})
export class SharedModule { }
